module.exports = __webpack_public_path__ + "img/donante-waldos.38308128.png";